import React, { lazy } from "react";
import { Box } from "@mui/material";
import HeroSection from "../components/HeroSection";
import LazySection from "../components/LazySection";

const Services = lazy(() => import("../components/Services"));
const Workflow = lazy(() => import("../components/Workflow"));
const About = lazy(() => import("../components/About"));
const Client = lazy(() => import("../components/client"));
const Ads = lazy(() => import("../components/ads"));
const Webshow = lazy(() => import("./services/components/Webshow"));

function Home() {
  return (
    <Box>
      <HeroSection />

      <Box sx={{ backgroundColor: "#e0e5ec" }}>
        <LazySection>
          <Services />
        </LazySection>

        <LazySection>
          <Ads />
        </LazySection>

        <LazySection>
          <Workflow />
        </LazySection>

        <LazySection>
          <Webshow />
        </LazySection>

        <LazySection>
          <About />
        </LazySection>

        <LazySection>
          <Client />
        </LazySection>
      </Box>
    </Box>
  );
}

export default Home;